import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";

import { getBrands } from "../../../../../redux/actions/brands";
import {
  assignHighlight,
  getFilteredCourses,
  showCourse,
  storeMassAssignment,
  toggleFormCourse,
} from "../../../../../redux/actions/courses";
import { getCoursetypes } from "../../../../../redux/actions/coursetypes";
import { getTags } from "../../../../../redux/actions/tags";
import { IRootState } from "../../../../../redux/types";
import { IFilter } from "../../models/course";

export const useCourses = () => {
  const { t } = useTranslation(["global"]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const courseState = useSelector((state: IRootState) => state.course);
  const { brands } = useSelector((state: IRootState) => state.brand);
  const { coursetypes } = useSelector((state: IRootState) => state.coursetype);
  const {
    globalFamilyId,
    globalBrandId,
    globalLineId,
    globalCountriesId,
    globalLanguageId,
  } = useSelector((state: IRootState) => state.global);
  const { tags } = useSelector((state: IRootState) => state.tag);

  const [openDeleteCourse, setOpenDeleteCourse] = useState(false);
  const [courseSelected, setCourseSelected] = useState<number | false>(false);
  const [rowsSelected, setRowsSelected] = useState<any[]>([]);
  const [filters, setFilters] = useState<IFilter>({
    family_id: null,
    brand_id: null,
    line_id: null,
    language_id: null,
    coursetype_id: null,
    orderby_id: 1,
    countries: [],
  });

  useEffect(() => {
    if (brands.length === 0) dispatch(getBrands());
    if (coursetypes.length === 0) dispatch(getCoursetypes());
    if (tags.length === 0) dispatch(getTags());
  }, []);

  useEffect(() => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      family_id: globalFamilyId,
      brand_id: globalBrandId,
      line_id: globalLineId,
      language_id: globalLanguageId,
      coursetype_id: null,
      countries: globalCountriesId,
      orderby_id: 1,
    }));
  }, [
    globalFamilyId,
    globalBrandId,
    globalLineId,
    globalLanguageId,
    globalCountriesId,
  ]);

  useEffect(() => {
    if (filters.countries.length > 0) {
      dispatch(getFilteredCourses(filters));
    }
  }, [filters]);

  useEffect(() => {
    if (globalLanguageId !== null) {
      dispatch(getCoursetypes());
    }
  }, [globalLanguageId]);

  useEffect(() => {
    if (courseState.reload) {
      dispatch(getFilteredCourses(filters));
    }
  }, [courseState.reload]);

  const handleChangeFilter = (coursetype_id: number): void => {
    setFilters((prevFilters) => ({ ...prevFilters, coursetype_id }));
  };

  const handleClickHighlight = (id: number, isHighlight: boolean) => {
    dispatch(assignHighlight({ id, isHighlight }));
  };

  const handleClickSetOptions = (options: any) => {
    dispatch(
      getFilteredCourses({
        brand_id: globalBrandId,
        line_id: globalLineId,
        language_id: globalLanguageId,
        countries: globalCountriesId,
        filterBy: options,
      })
    );
  };

  const handleOrganizeCourses = () => {
    navigate("/admin/cursos/ordenamiento");
  };

  const handleSubmitMassAssignment = (data: any) => {
    dispatch(storeMassAssignment(data));
  };

  const handleEditCourse = (id: number) => {
    dispatch(showCourse(id));
    dispatch(toggleFormCourse());
  };

  const handleDeleteCourse = (id: number) => {
    setOpenDeleteCourse(true);
    setCourseSelected(id);
  };

  return {
    courseState,
    brands,
    coursetypes,
    tags,
    filters,
    openDeleteCourse,
    setOpenDeleteCourse,
    courseSelected,
    rowsSelected,
    globalBrandId,
    setFilters,
    setRowsSelected,
    handleChangeFilter,
    handleClickHighlight,
    handleClickSetOptions,
    handleSubmitMassAssignment,
    handleEditCourse,
    handleDeleteCourse,
    handleOrganizeCourses,
    history,
    t,
  };
};
